import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IZoomProps {
  level: number; // TODO: currently supports only 0.7, make the maths to make work with any value
}

const blockName = 'zoom';

export default function Zoom({ children }: React.PropsWithChildren<IZoomProps>) {
  const bem = bemBlock(blockName);
  const level = 0.7; // TODO: currently supports only 0.7, make the maths to make work with any value
  const perspective = 10;

  return (
    <div
      className={bem()}
      style={{
        perspective,
      }}
    >
      <div
        className={bem('container')}
        style={{
          transform: `scale3d(${level}, ${level}, ${level}) translate(-21%, -21%)`,
        }}
      >
        {children}
      </div>
    </div>
  );
}
